interface IUniframe {
  security: any;
  securityItem: any;
}

const useSecurityPreload = () => {
  if (typeof window === 'undefined' || !window.BybitUniFrame) return;

  window.BybitUniFrame?.ready(({ security, securityItem }: IUniframe) => {
    // 初始化security
    setTimeout(() => {
      const { PRESTRAIN } = securityItem.properties;
      if (
        ['/app/user/security', '/app/user/account-info'].includes(
          window.location.pathname,
        )
      ) {
        securityItem.setProperty(PRESTRAIN, true);
      }
      security.init();
    }, 8000);
  });
};

export default useSecurityPreload;
